import { trigger, state, style, transition, animate, query, animateChild } from '@angular/animations';


export const categoryAnimation =
  trigger('categoryAnimation', [
    transition('onHide <=> onHover', [
      query('@categoryImageAnimation', animateChild())
    ])
  ]);

export const categoryImageAnimation =
  trigger('categoryImageAnimation', [
    state('onHide', style({
      transform: 'translate(10px, 90px) rotate(0deg) scale(1.1)',
      opacity: 0
    })),
    state('onHover', style({
      transform: 'translate(0px, 0px) rotate(-2deg) scale(1)',
      opacity: 1
    })),
    transition('onHide => onHover', [
      animate('0.5s cubic-bezier(.38,.02,0,1.1)', style({
        transform: 'translate(0px, 0px) rotate(-2deg) scale(1)',
        opacity: 1
      }))
    ]),
    transition('onHover => onHide', [
      animate('0.2s cubic-bezier(0.1, 1.15, 0.6, 0.97)', style({
        transform: 'translate(10px, 90px) rotate(0deg) scale(1.1)',
        opacity: 0
      }))
    ]),
  ]);
